import { OnEventDispatcher } from "../core/on-event-dispatcher";
import { ReceptionOutDatabaseShortInfo, ReceptionProximityInfo, Receptions } from '../io/receptions';
import { GoogleMaps } from "../core/googlemaps";
import { MapOptions } from "./mapoptions";
import { VaxiluskernaMarker } from "./vaxiluskernamarker";
import { VaxiluskernaCountry } from "./vaxiluskernacountry";
import { WorldGeom, WorldGeomCountry } from "../io/worldgeom";
import { Application } from "../main";
import { delay } from "../core/delay";
export class VaxiluskernaMap extends OnEventDispatcher {
    
    googlemaps: GoogleMaps;

    private needsUpdate:boolean = false; //set to true anytime map has changed
    elm: JQuery<HTMLElement>;

    tooltip: JQuery<HTMLElement>;
    tooltipInner: JQuery<HTMLElement>;
    tooltipInnerText: JQuery<HTMLElement>;
    tooltipVisible:boolean = false;

    worldMode: boolean = false;
    
    constructor() {
        super();
    }

    public mount(container:JQuery<HTMLElement>):Promise<void> {
        return new Promise(async (resolve, reject) => {
            this.elm = $("<div class='vaxiluskerna-map'></div>").appendTo(container);
            this.tooltip = $("<div class='vaxiluskerna-tooltip'><div class='vaxiluskerna-tooltip-inner'><div class='vaxiluskerna-tooltip-inner-text'>Test</div></div></div>").appendTo(this.elm);
            this.tooltipInner = this.tooltip.find(".vaxiluskerna-tooltip-inner");
            this.tooltipInnerText = this.tooltipInner.find(".vaxiluskerna-tooltip-inner-text");
            this.tooltip.hide();
            try {
                this.googlemaps = new GoogleMaps(this.elm, MapOptions);
                await this.googlemaps.mount();
                this.googlemaps.on("bounds_changed", () => {
                    Receptions.onMapBounds(this.googlemaps.bounds);
                });
                this.elm.on("mousemove", (e) => {this.onMouseMove(e)})
                resolve();
            } catch(e) {
                reject(e);
            }
        });
    }

    onMouseMove(e:JQuery.MouseMoveEvent) {
        if(this.tooltipVisible) {
            this.tooltip.css("top", e.clientY+"px");
            this.tooltip.css("left", e.clientX+"px");
        }
    }

    public showTooltip(text:string) {
        this.tooltipInnerText.html(text);
        this.tooltip.show();
        this.tooltipVisible = true;
    }
    public hideTooltip() {
        this.tooltipInnerText.html("");
        this.tooltip.hide();
        this.tooltipVisible = false;
    }

    public hideReceptionMarkers() {
        for(let m in Receptions.receptions) {
            let c = Receptions.receptions[m];
            c.marker.setHide(true);
        }
    }
    public showReceptionMarkers() {
        for(let m in Receptions.receptions) {
            let c = Receptions.receptions[m];
            c.marker.setHide(false);
        }
    }
    public hideDestinations() {
        for(let m in WorldGeom.countries) {
            let c = WorldGeom.countries[m];
            c.vaxiCountry.setHide(true);
        }
    }
    public showDestinations() {
        for(let m in WorldGeom.countries) {
            let c = WorldGeom.countries[m];
            c.vaxiCountry.setHide(false);
        }
    }
    public async setWorldMode(worldMode:boolean) {
        if(worldMode&&!this.worldMode) {
            this.worldMode = worldMode;
            this.hideReceptionMarkers();
            this.showDestinations();
            Application.events.dispatch("enter-world-mode");
        } else if(!worldMode&&this.worldMode) {
            this.worldMode = worldMode;
            this.hideDestinations();
            this.showReceptionMarkers();
            Application.events.dispatch("exit-world-mode");
        }
    }
    
    public addReceptionMarker(reception : ReceptionOutDatabaseShortInfo):VaxiluskernaMarker {
        let basepath:string = "static/img/pin-icons/";
        let idpath:string = "default-";
        let ext:string = ".png";

        if(reception.group=="vaccindirekt") {
            idpath = "vaccindirekt-";
        } else if(reception.group=="sveavaccin") {
            idpath = "sveavaccin-";
        }

        let marker = new VaxiluskernaMarker(this, {
            group: "receptions",
            position: reception.position,
            icon: {
                highlight: basepath+idpath+"highlight"+ext,
                idle: basepath+idpath+"idle"+ext,
                peripheral: basepath+idpath+"peripheral"+ext,
                tiny: basepath+"default-sm-idle"+ext,
                tinyperipheral: basepath+"default-sm-peripheral"+ext
            },
            title: reception.name
        });
        reception.marker = marker;        
        return marker;
    }
    public addDestination(destination : WorldGeomCountry):VaxiluskernaCountry {
        let vaxiCountry = new VaxiluskernaCountry(this, {
            geomCountry: destination
        });
        destination.vaxiCountry = vaxiCountry;
        return vaxiCountry;
    }
    public setBoundsToIncludeReceptions(receptions:{[key: string]: ReceptionOutDatabaseShortInfo}|Array<ReceptionProximityInfo>|Array<ReceptionOutDatabaseShortInfo>):void {
        let latLngArr:Array<{lat:number, lng:number}> = [];
        let receptionsAny:any = receptions;
        for(let m in receptionsAny) {
            let reception:ReceptionOutDatabaseShortInfo = receptionsAny[m] as ReceptionOutDatabaseShortInfo;
            if(receptionsAny[m].distance!=null) reception = (receptionsAny[m] as ReceptionProximityInfo).reception;
            latLngArr.push({lat: reception.position.lat, lng: reception.position.lng});
        }
        this.googlemaps.fitBounds(this.googlemaps.createBounds(latLngArr), {x: 300, y: 0});
    }
    public zoomInOnReception(c: ReceptionOutDatabaseShortInfo):void {
        this.setBoundsToIncludeReceptions([c]);
        this.googlemaps.setZoom(15);
    }
    public zoomInOnDestination(c: WorldGeomCountry):void {
        this.googlemaps.fitBounds(c.vaxiCountry.bounds, {x: 300, y: 0});
    }
    
}